import {
  call,
  all,
  ForkEffect,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import {
  updateFormSubmissionSuccess,
  updateFormSubmissionError,
  formSubmissionActions,
  deleteFormSubmissionSuccess,
  deleteFormSubmissionError,
  addFormSubmissionSuccess,
  addFormSubmissionError,
  fetchFormSubmissionsSuccess,
  fetchFormSubmissionsError,
  fetchFormSubmissionSettingsFailureAction,
  fetchFormSubmissionSettingsSuccessAction,
  fetchMySubmissionsSuccess,
  fetchMySubmissionsFailure,
  fetchSubmissionBySubmissionIdSuccess,
  fetchSubmissionBySubmissionIdFailure,
  checkDuplicateSubmissionSuccess,
  checkDuplicateSubmissionError,
  setActiveFormSubmissionSucces,
  bulkUpdateSubmissionValuesSuccess,
  updateSubmissionDataSuccess,
  respondedSubmissionData,
  setSubmisisonType,
  deleteDatagridFormSubmission,
  deleteDatagridFormSubmissionError,
  deleteDatagridFormSubmissionSuccess,
  addDataGridSubmissionField,
  formOpenedSuccess,
  formOpenedFailure,
  sendOrValidateOTPSuccess,
  sendOrValidateOTPError,
} from "./actions";
import { FormSubmissionRepository } from "@common/domain/repositories/FormSubmissionRepository";
import {
  IFetchFormSubmissionsAction,
  IFetchFormSubmissionsApiResponse,
  IFetchFormSubmissionSettingsFailureActionPayload,
  IFetchFormSubmissionSettingsSuccessActionPayload,
  IFormSubmission,
  IFormSubmissionReducerState,
  ISubmissionFormDataServer,
  IFormSubmissionPagination,
  IFieldSubmissionMap,
  IDuplicateCheckFormData,
  ICheckDuplicateSubmissionResponse,
  ISubmissionFormFieldDataServer,
  Events,
  IFetchPinCode,
  IRespondedBySubmissionMap,
  ICheckDuplicateSubmissionFieldSuccessResponsePayload,
  IQRCodeData,
} from "@common/redux/formSubmission/interface";
import {
  getActiveFormSubmissionSelector,
  getDataGridActionsMapperSelector,
  getFormOpenedDate,
  getFormSubmissionRespondedByData,
  getIsDraftSelector,
  getSubmissionMapSelector,
} from "@common/redux/formSubmission/selectors";
import {
  getUserIdFromSubmission,
  handleCallJavascript,
  transFormSubmissionDataClientToServer,
  transFormSubmissionDataServerToClient,
  transFormSubmissionDataToCheckDuplicate,
  validateFormRuleForWorkflow,
} from "@common/redux/formSubmission/utils";
import {
  fetchFormsByIdsAction,
  fetchWorkflowByFormIdAction,
} from "@common/redux/forms/actions";
import {
  fetchFormByIdsSaga,
  fetchWorkflowSaga,
} from "@common/redux/forms/sagas";
import {
  fetchFormsMapSelector,
  fetchWorkflowMapSelector,
  getActiveCustomPermissionSelector,
} from "@common/redux/forms/selectors";
import {
  ICustomPermission,
  IFormsMap,
  IWorkflowMap,
} from "@common/redux/forms/interface";
import {
  IFetchFormSubmissionsDataToExportAction,
  IFetchFormSubmissionsDataToExportRepositoryPayload,
} from "@common/redux/formSubmission/interface";
import {
  getActiveSubmissionType,
  getFieldsMapOfActiveFormSelector,
  getFieldsToShowAndHideSelector,
  getPageToShowAndHideSelector,
  getCompositeKeyField,
  getUpdatedHiddenFields,
  getActiveFormDataSelector,
} from "../formBuilder/selectors";
import { getProcessDataFromUrl } from "@common/utils/getProcessDataFromUrl";
import {
  IFieldsMap,
  IFieldsToHIdeAndShow,
  IPageToHIdeAndShow,
  submisionType,
  ICompositeKeyFields,
  IForm,
} from "../formBuilder/interface";
import { validateFieldRuleAction } from "../formBuilder/actions";
import { getPagesWithHideAction } from "../forms/utils";

export interface IformSubmissionDataInServerFormat {
  id?: string;
  formId: string;
  formData: ISubmissionFormFieldDataServer;
  createdDate?: string;
  taskId?: string;
  processInstanceId?: string;
  assignedTo?: string;
  workFlowIds?: string[];
  isDraft?: boolean; // new flag for draft is added to Submission form (25042024)
}

const getformSubmission = (state) => state.formSubmission;

function* fetchFormSubmissionsSaga(action: IFetchFormSubmissionsAction): any {
  try {
    const fetchFormsSubmissionPayload = action?.payload;
    const response: IFetchFormSubmissionsApiResponse = yield call(
      FormSubmissionRepository?.fetchFormSubmissions,
      fetchFormsSubmissionPayload
    );
    const submissions: ISubmissionFormDataServer[] = response?.content;
    // const fetchedFormIds: string[] = [... new Set(submissions?.map(submissions => submissions?.formId ))]
    let fetchedFormIds: string[] = [];
    submissions?.forEach((formSubmissions: ISubmissionFormDataServer) => {
      const { formId } = formSubmissions;
      if (!fetchedFormIds?.includes(formId)) {
        fetchedFormIds = [...fetchedFormIds, formId];
      }
    });
    yield call(fetchFormByIdsSaga, fetchFormsByIdsAction(fetchedFormIds));

    const formsMap: IFormsMap = yield select(fetchFormsMapSelector);
    const fetchedFormsMap: IFormsMap = {};
    fetchedFormIds?.forEach((formId: string) => {
      fetchedFormsMap[formId] = formsMap[formId];
    });

    yield put(fetchFormSubmissionsSuccess({ fetchedFormsMap, response }));
  } catch (e) {
    yield put(fetchFormSubmissionsError(e.message));
  }
}

function* updateFormSubmissionSaga(action): any {
  const formSubmission: IFormSubmissionReducerState = yield select(
    getformSubmission
  );
  // const formSubmissionData = action.payload.formSubmissionData;

  const formSubmissionData = formSubmission.activeFormSubmission;
  const formId = action.payload.formId;

  const { response, error } = FormSubmissionRepository.updateFormSubmission(
    formId,
    formSubmissionData
  );
  if (response) {
    yield put(updateFormSubmissionSuccess(response.dbFormattedSubmissionData));
  } else {
    yield put(updateFormSubmissionError(error));
  }
}

function* addFormBulkSubmissionSaga(action): any {
  try {
    const activeFormSubmission = yield select(getActiveFormSubmissionSelector);
    const fieldsMap = yield select(getFieldsMapOfActiveFormSelector);
    const datagridMapper = yield select(getDataGridActionsMapperSelector);
    const serverData = [];
    Object.keys(datagridMapper).forEach((gridId: string) => {
      if (fieldsMap[gridId]) {
        const sourceFormId =
          fieldsMap?.[gridId]?.fieldValue?.referenceFormId;
        const formSubmissionDataInServerFormat = {
          ...getProcessDataFromUrl(),
          ...transFormSubmissionDataClientToServer(
            activeFormSubmission,
            sourceFormId,
            [],
            [],
            fieldsMap
          ),
        };

        Object.keys(datagridMapper[gridId]).forEach((submissionId) => {
          const value = datagridMapper[gridId][submissionId];
          if (value == "NEW") {
            const gridSubmissionData: any =
              formSubmissionDataInServerFormat.formData[gridId];
            if (gridSubmissionData?.length) {
              gridSubmissionData?.forEach((rowData) => {
                if (rowData._id == submissionId) {
                  const temp = { ...rowData };
                  delete temp._id;
                  const submissionData = {
                    formId: sourceFormId || fieldsMap?.[gridId]?.fieldValue?.referenceFormId,
                    formData: temp,
                    relatedSubmissionIds: [],
                  };
                  if(sourceFormId?.length){
                  serverData.push(submissionData);
                  }
                }
              });
            }
          }
        });
      }
    });
    if (serverData?.length) {
      const payload = {
        formDataDtoList: serverData,
      };
      yield call(FormSubmissionRepository.addBulkFormSubmission, payload);
    }
  } catch (e) {
    const formSubmissionFailureCallback =
      action.payload?.formSubmissionFailureCallback;
    formSubmissionFailureCallback && formSubmissionFailureCallback(e?.message);
    yield put(addFormSubmissionError(e.message));
  }
}
function* updateFormBulkSubmissionSaga(action): any {
  try {
    const activeFormSubmission = yield select(getActiveFormSubmissionSelector);
    const fieldsMap = yield select(getFieldsMapOfActiveFormSelector);
    const datagridMapper = yield select(getDataGridActionsMapperSelector);
    const serverData = [];
    Object.keys(datagridMapper).forEach((gridId: string) => {
      if (fieldsMap[gridId]) {
        const sourceFormId =
          fieldsMap?.[gridId]?.fieldValue?.defaultValue?.tableMapping
            ?.selectedForm?.value;
        const formSubmissionDataInServerFormat = {
          ...getProcessDataFromUrl(),
          ...transFormSubmissionDataClientToServer(
            activeFormSubmission,
            sourceFormId,
            [],
            [],
            fieldsMap
          ),
        };

        Object.keys(datagridMapper[gridId]).forEach((submissionId) => {
          const value = datagridMapper[gridId][submissionId];
          if (value != "NEW") {
            const gridSubmissionData: any =
              formSubmissionDataInServerFormat.formData[gridId];
            if (gridSubmissionData) {
              gridSubmissionData?.forEach((rowData) => {
                if (rowData._id == submissionId) {
                  const temp = { ...rowData };
                  delete temp._id;
                  const submissionData = {
                    id: submissionId,
                    formId: sourceFormId,
                    formData: temp,
                    relatedSubmissionIds: [],
                  };
                  serverData.push(submissionData);
                }
              });
            }
          }
        });
      }
    });

    const payload = {
      formDataDtoList: serverData,
    };
    if (serverData?.length) {
      const addFormSubmissionResponse: ISubmissionFormDataServer = yield call(
        FormSubmissionRepository.updateBulkFormSubmission,
        payload
      );
    }
  } catch (e) {
    const formSubmissionFailureCallback =
      action.payload?.formSubmissionFailureCallback;
    formSubmissionFailureCallback && formSubmissionFailureCallback(e?.message);
    yield put(addFormSubmissionError(e.message));
  }
}

function* addFormSubmissionSaga(action): any {
  try {
    const formId = action.payload.formId;
    const roleName = action.payload?.roleName;
    const submissionId = action.payload.id;
    const qrCodeData: IQRCodeData = action?.payload?.qrcodeData;
    const qrCodeBase64 = qrCodeData?.qrCodeBase64 ?? "";
    const qrFieldId = qrCodeData?.qrCodeFieldId ?? "";
    const formSubmissionSuccessCallback =
      action.payload?.formSubmissionSuccessCallback;
    const activeFormSubmission: IFormSubmission = yield select(
      getActiveFormSubmissionSelector
    );
    const activeForm: IForm = yield select(
      getActiveFormDataSelector
    );
    const isScriptOnSubmission = activeForm?.isScriptOnFormSubmission ?? false
    const scriptOnFormSubmission = activeForm?.scriptOnSubmission ?? ""

    const fieldsMap: IFieldsMap = yield select(
      getFieldsMapOfActiveFormSelector
    );
    const fieldsToHide: IFieldsToHIdeAndShow = yield select(
      getFieldsToShowAndHideSelector
    );
    const datagridMapper = yield select(getDataGridActionsMapperSelector);
    const submissionMap = yield select(getSubmissionMapSelector);
    const openedDate: number = yield select(getFormOpenedDate);

    const formSubmissionDataInServerFormat: IformSubmissionDataInServerFormat =
      {
        ...getProcessDataFromUrl(),
        ...transFormSubmissionDataClientToServer(
          activeFormSubmission,
          formId,
          fieldsToHide.hide,
          [],
          fieldsMap,
          openedDate,
          datagridMapper,
          submissionMap
        ),
      };
    if (submissionId) formSubmissionDataInServerFormat.id = submissionId;
    const userId = getUserIdFromSubmission(
      formSubmissionDataInServerFormat.formData
    );
    if (userId) {
      formSubmissionDataInServerFormat.assignedTo = userId;
    }
    // formSubmissionDataInServerFormat.workFlowIds = validWorkflowIds;

    /**
     * isSaveInDraft flag is used to identify
     * Save to Draft from Form Submission
     */
    const { isSaveInDraft } = action.payload;

    if (isSaveInDraft) {
      formSubmissionDataInServerFormat.isDraft = true;
    }
    let isDraftOption: boolean = yield select(getIsDraftSelector);
    if (submissionId && !isDraftOption && qrCodeBase64 != "") {
      let formData = formSubmissionDataInServerFormat?.formData;
      if (Object.keys(formData ?? {}).length == 0) return;
      formData = {
        ...formData,
        [qrFieldId]: qrCodeBase64,
      };
      formSubmissionDataInServerFormat.formData = formData;
    }
    const addFormSubmissionResponse: ISubmissionFormDataServer = yield call(
      submissionId && !isDraftOption
        ? FormSubmissionRepository.resubmitFormSubmission
        : FormSubmissionRepository.addFormSubmission,
         formSubmissionDataInServerFormat,
         roleName
    );
    let existingFormsMap: IFormsMap = yield select(fetchFormsMapSelector);
    if (!existingFormsMap[formId]) {
      yield call(fetchFormByIdsSaga, fetchFormsByIdsAction([formId]));
    }
    existingFormsMap = yield select(fetchFormsMapSelector);
    const updatedSubmissionMap: IFormSubmission =
      transFormSubmissionDataServerToClient(
        addFormSubmissionResponse,
        existingFormsMap[formId],
        fieldsToHide?.hide
      );
    formSubmissionSuccessCallback &&
      formSubmissionSuccessCallback(addFormSubmissionResponse);
    if (isScriptOnSubmission && scriptOnFormSubmission) {
      new handleCallJavascript(scriptOnFormSubmission,formSubmissionDataInServerFormat)
    }
    yield put(addFormSubmissionSuccess(updatedSubmissionMap));
  } catch (e) {
    const formSubmissionFailureCallback =
      action.payload?.formSubmissionFailureCallback;
    formSubmissionFailureCallback && formSubmissionFailureCallback(e?.message);
    yield put(addFormSubmissionError(e.message));
  }
}

function* deleteFormSubmissionSaga(action): any {
  const formSubmission: IFormSubmissionReducerState = yield select(
    getformSubmission
  );
  const index = action.payload.index;
  const formId = action.payload.formId;

  const formSubmissionMap = formSubmission.formSubmissionMap;

  const submissionFormId = formSubmissionMap[formId][index];

  const { response, error } = FormSubmissionRepository.deleteFormSubmission(
    formId,
    submissionFormId
  );
  if (response) {
    yield put(deleteFormSubmissionSuccess(formId, index));
  } else {
    yield put(deleteFormSubmissionError(error));
  }
}

function* sendOrValidateOTPSaga(action): any {
  try {
    const payload = action.payload;

    const response = yield call(
      FormSubmissionRepository.sendOrValidateOTP,
      payload
    );

    yield put(sendOrValidateOTPSuccess(response));
  } catch (error) {
    yield put(sendOrValidateOTPError(error?.message));
  }
}

function* deleteDatagridSubmissionSaga(action): any {
  const formSubmission: IFormSubmissionReducerState = yield select(
    getformSubmission
  );
  const index = action.payload.index;
  const submissionId = action.payload.submissionId;

  const formSubmissionMap = formSubmission.formSubmissionMap;
  try {
    const response = yield call(
      FormSubmissionRepository.deleteFormSubsmission,
      submissionId
    );
    yield put(deleteDatagridFormSubmissionSuccess(submissionId, index));
  } catch (error) {
    yield put(deleteDatagridFormSubmissionError(error));
  }
}

function* fetchFormSubmissionsDataToExportSaga(
  action: IFetchFormSubmissionsDataToExportAction
): any {
  const {
    formId,
    onSuccessFileFetch,
    onFailureFileFetch,
    fromDate,
    toDate,
    fileType,
  } = action.payload;
  try {
    const defaultFromDate = new Date("2022-01-01").getTime();
    const defaultToDate = Date.now();
    const submissionExportApiPayload: IFetchFormSubmissionsDataToExportRepositoryPayload =
      {
        formId,
        fromDate: fromDate ? fromDate : defaultFromDate, //new Date("2022-01-01").toISOString(),
        toDate: toDate ? toDate : defaultToDate, //new Date().toISOString() ,
        fileType: fileType,
      };
    const fileFetchedToExport: any = yield call(
      FormSubmissionRepository.formSubmissionsExport,
      submissionExportApiPayload
    );
    onSuccessFileFetch(fileFetchedToExport);
  } catch (e) {
    onFailureFileFetch(e.message);
  }
}

function* fetchFormSubmissionSettingsSaga(action) {
  try {
    const formId: string = action?.payload?.formId;
    const response = yield call(
      FormSubmissionRepository.fetchFormSubmissionSettings,
      formId
    );
    const fetchFormSubmissionSettingsPayload: IFetchFormSubmissionSettingsSuccessActionPayload =
      {
        isMultipleSubmissionAllowed: true,
        formId,
      };
    yield put(
      fetchFormSubmissionSettingsSuccessAction(
        fetchFormSubmissionSettingsPayload
      )
    );
  } catch (e) {
    const formId: string = action?.payload?.formId; // is it proper method?
    const fetchFormSubmissionSettingsFailurePayload: IFetchFormSubmissionSettingsFailureActionPayload =
      {
        isMultipleSubmissionAllowed: false,
        formId,
        error: e.message,
      };
    yield put(
      fetchFormSubmissionSettingsFailureAction(
        fetchFormSubmissionSettingsFailurePayload
      )
    );
  }
}

function* geMySubmittedFormsSaga(action) {
  try {
    const response: IFetchFormSubmissionsApiResponse = yield call(
      FormSubmissionRepository.fetchMySubmissions,
      action.payload
    );
    const {
      totalElements,
      totalPages,
      pageNumber,
      pageSize,
      content: formResponses,
    } = response;
    const mySubmissionPaginationData: IFormSubmissionPagination = {
      totalElements: totalElements,
      totalPages: totalPages,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    let fetchedFormIds: string[] = [];
    let mySubmissionIds: string[] = [];

    let mySubmissionsMap: IFieldSubmissionMap[];
    formResponses?.forEach((formSubmission: ISubmissionFormDataServer) => {
      const { formId } = formSubmission;
      if (!fetchedFormIds?.includes(formId)) {
        fetchedFormIds = [...fetchedFormIds, formId];
      }
    });
    const fetchFormsSagaCalls = [];

    for (const formId of fetchedFormIds) {
      const existingFormsMap = yield select(fetchFormsMapSelector);
      if (!existingFormsMap[formId]) {
        fetchFormsSagaCalls.push(
          call(fetchFormByIdsSaga, fetchFormsByIdsAction([formId]))
        );
      }
    }
    yield all([...fetchFormsSagaCalls]);
    const fieldsToHide: IFieldsToHIdeAndShow = yield select(
      getFieldsToShowAndHideSelector
    );
    const formsMap: IFormsMap = yield select(fetchFormsMapSelector);
    formResponses?.forEach((formSubmission: ISubmissionFormDataServer) => {
      const { formId, id, createdDate } = formSubmission;

      mySubmissionIds = [...mySubmissionIds, id];
      let updatedSubmissionMap: IFormSubmission =
        transFormSubmissionDataServerToClient(
          formSubmission,
          formsMap[formId],
          fieldsToHide.hide ?? []
        );
      updatedSubmissionMap = {
        ...updatedSubmissionMap,
        submittedDate: createdDate,
      };
      mySubmissionsMap = {
        ...mySubmissionsMap,
        [id]: updatedSubmissionMap,
      };
    });

    yield put(
      fetchMySubmissionsSuccess(
        mySubmissionPaginationData,
        mySubmissionsMap,
        mySubmissionIds
      )
    );
  } catch (e) {
    yield put(fetchMySubmissionsFailure(e.message));
  }
}

function* getSubmissionBySubmissionIdSaga(action) {
  try {
    const response: ISubmissionFormDataServer = yield call(
      FormSubmissionRepository.fetchSubmissionBySubmissionId,
      action.payload.submissionId,
       action.payload?.roleName
    );
    const isDraft: boolean = response.isDraft ?? false;
    const { formId, id, userId,makerEmail,makerLevel,updatedByEmail,updatedByLevel,} = response;

    let respondedByData = {
      ...response?.respondedBy,
      createdById: userId,
      makerEmail:makerEmail,
      makerLevel: makerLevel,
      updatedByEmail:updatedByEmail,
      updatedByLevel: updatedByLevel
    };

    const respondedByDataMap = {
      [id]: respondedByData,
    };
    yield put(respondedSubmissionData(respondedByDataMap));
    yield put(setSubmisisonType(isDraft));
    let existingFormsMap: IFormsMap = yield select(fetchFormsMapSelector);
    if (!existingFormsMap[formId]) {
      yield call(fetchFormByIdsSaga, fetchFormsByIdsAction([formId]));
      yield call(fetchWorkflowSaga, fetchWorkflowByFormIdAction(formId));
    }
    existingFormsMap = yield select(fetchFormsMapSelector);
    const fieldsToHide: IFieldsToHIdeAndShow = yield select(
      getFieldsToShowAndHideSelector
    );
    const updatedSubmissionMap: IFormSubmission =
      transFormSubmissionDataServerToClient(
        response,
        existingFormsMap[formId],
        fieldsToHide.hide ?? []
      );

    const SubmissionsMap: IFieldSubmissionMap = {
      [id]: updatedSubmissionMap,
    };
    yield put(fetchSubmissionBySubmissionIdSuccess(SubmissionsMap));
  } catch (e) {
    yield put(fetchSubmissionBySubmissionIdFailure(e.message));
  }
}

function* checkDuplicateSubmission(action) {
  try {
    const formId = action.payload.formId;
    const submissionId = action.payload.submissionId;
    const activeFormSubmission: IFormSubmission = yield select(
      getActiveFormSubmissionSelector
    );

    const fieldsToHideAndShow: IFieldsToHIdeAndShow = yield select(
      getFieldsToShowAndHideSelector
    );
    const pageToHideAndShow: IPageToHIdeAndShow = yield select(
      getPageToShowAndHideSelector
    );
    const formCompositeKeyFields = yield select(getCompositeKeyField);

    const updatedHiddenFields = yield select(getUpdatedHiddenFields);
    const pageToHide: string[] = pageToHideAndShow?.skip || [];
    const fieldsToHide: string[] = fieldsToHideAndShow?.hide;
    const fieldsMap = yield select(getFieldsMapOfActiveFormSelector);
    const permission: ICustomPermission = yield select(
      getActiveCustomPermissionSelector
    );
    const configPageId = getPagesWithHideAction(
      permission.formPage[formId] ?? {}
    );
    const submissionDataToCheckDuplicate: IDuplicateCheckFormData =
      transFormSubmissionDataToCheckDuplicate(
        activeFormSubmission,
        formId,
        fieldsToHide,
        pageToHide,
        fieldsMap,
        submissionId,
        configPageId,
        formCompositeKeyFields,
        updatedHiddenFields
      );
    const addFormSubmissionResponse: ICheckDuplicateSubmissionResponse =
      yield call(
        FormSubmissionRepository.checkDuplicateSubmission,
        submissionDataToCheckDuplicate
      );
    const duplicateSubmissionData: ICheckDuplicateSubmissionFieldSuccessResponsePayload =
      {
        fieldData: addFormSubmissionResponse.fieldDetails,
        isCompositeFieldsDuplicate:
          addFormSubmissionResponse.isCompositeFieldsDuplicate,
        compositeFieldData: addFormSubmissionResponse.compositeFieldDetails,
      };
    yield put(checkDuplicateSubmissionSuccess(duplicateSubmissionData));
  } catch (e) {
    yield put(checkDuplicateSubmissionError(e.message));
  }
}

function* setActiveSubmission(action: any) {
  yield put(
    setActiveFormSubmissionSucces(action.payload.activeFormSubmissionId)
  );
}
function* getPincodeDataSaga(action: IFetchPinCode) {
  const { onSuccessPincodeData, onFailure, pincode, countryCode } =
    action.payload;
  try {
    const formFilesUploadResponse = yield call(
      FormSubmissionRepository.fetchPincodeData,
      pincode,
      countryCode
    );
    onSuccessPincodeData(formFilesUploadResponse?.data?.result);
  } catch (error) {
    onFailure(error);
  }
}

function* bulkUpdateSubmissionData(action: any) {
  yield put(
    bulkUpdateSubmissionValuesSuccess(
      action.payload?.fieldIds,
      action.payload?.data
    )
  );
  yield put(validateFieldRuleAction(""));
}

function* updateSubmissionData(action: any) {
  yield put(
    updateSubmissionDataSuccess(action.payload.data, action.payload.index)
  );
  yield put(validateFieldRuleAction(""));
}

function* handleFormOpened(action: any) {
  try {
    const response = yield call(
      FormSubmissionRepository.formOpenedApi,
      action.payload
    );
    yield put(formOpenedSuccess(response));
  } catch (error) {
    yield put(formOpenedFailure(error.message));
  }
}

export function* watchFormSubmission(): Generator<ForkEffect> {
  yield takeLatest(
    formSubmissionActions.FETCH_MY_SUBMISSIONS,
    geMySubmittedFormsSaga
  );
  yield takeLatest(
    formSubmissionActions.FETCH_PINCODE_DATA,
    getPincodeDataSaga
  );
  yield takeLatest(
    formSubmissionActions.FETCH_SUBMISSION_BY_SUBMISSION_ID,
    getSubmissionBySubmissionIdSaga
  );

  yield takeLatest(
    formSubmissionActions.FETCH_FORM_SUBMISSIONS,
    fetchFormSubmissionsSaga
  );

  yield takeLatest(
    formSubmissionActions.UPDATE_FORM_SUBMISSION,
    updateFormSubmissionSaga
  );
  yield takeLatest(
    formSubmissionActions.ADD_FORM_SUBMISSION,
    addFormSubmissionSaga
  );
  yield takeLatest(
    formSubmissionActions.SEND_OR_VALIDATE_OTP,
    sendOrValidateOTPSaga
  );
  yield takeLatest(
    formSubmissionActions.DELETE_FORM_SUBMISSION,
    deleteFormSubmissionSaga
  );
  yield takeLatest(
    formSubmissionActions.DELETE_DATAGRID_FORM_SUBMISSION,
    deleteDatagridSubmissionSaga
  );

  yield takeEvery(
    formSubmissionActions.FORM_SUBMISSIONS_EXPORT,
    fetchFormSubmissionsDataToExportSaga
  );
  yield takeLatest(
    formSubmissionActions.FETCH_FORM_SUBMISSION_SETTINGS,
    fetchFormSubmissionSettingsSaga
  );

  yield takeLatest(
    formSubmissionActions.CHECK_DUPLICATE_VALUE,
    checkDuplicateSubmission
  );
  yield takeLatest(
    formSubmissionActions.SET_ACTIVE_FORM_SUBMISSION,
    setActiveSubmission
  );
  yield takeLatest(
    formSubmissionActions.BULK_UPDATE_FORM_DATA,
    bulkUpdateSubmissionData
  );
  yield takeLatest(
    formSubmissionActions.UPDATE_FIELD_DATA,
    updateSubmissionData
  );
  yield takeLatest(
    formSubmissionActions.ADD_FORM_BULK_SUBMISSION,
    addFormBulkSubmissionSaga
  );
  yield takeLatest(
    formSubmissionActions.UPDATE_FORM_BULK_SUBMISSION,
    updateFormBulkSubmissionSaga
  );
  yield takeLatest(formSubmissionActions.FORM_OPENED_REQUEST, handleFormOpened);
}
